import React, {useCallback, useEffect, useState, useMemo} from 'react';
import {
	Slider,
	Button,
} from '@kaleyra/emmy';
import Styles from './modal.module.scss';
import { useTranslation } from 'react-i18next';
import StandardTitle from "../../../../components/StandardTitle";
import {validateTitle} from "../../../../utils";

export type MapStateToPropsType = {
	params: any;
};

export type MapDispatchToPropsType = {
	onClose: () => void;
};

const RenameACL: React.FC<MapStateToPropsType & MapDispatchToPropsType> = (
	{
		onClose,
		params,
	}) => {
	const [title, setTitle] = useState<undefined|string>(undefined);
	const { t } = useTranslation();
	const { title:groupName, handleRenameSipAcl } = params;

	useEffect(()=>{
			setTitle(groupName);
	},[])

	const handleSave = useCallback(() => {
		if(!title) return;
		onClose();
		handleRenameSipAcl(title);
	},[title]);

	const enableSaveButton = useMemo(() => {
		if(!title) return false;
		return validateTitle(title);
	},[title]);

	const renderFooter = () => {
		return (
			<div className={Styles.footer}>
				<span className={Styles.cancelBtn}>
					<Button type="tertiary" onClick={onClose}>
						{t('mainCancel')}
					</Button>
				</span>
				<Button
					disabled={!enableSaveButton}
					type="primary"
					onClick={handleSave}
				>
					{t('mainSave')}
				</Button>
			</div>
		);
	};

	return (
		<Slider
			title={t('KLR00710')}
			containerId="root-modal"
			onClose={onClose}
			visibility={true}
			footer={renderFooter()}
		>
			<div className={Styles.container}>
				<StandardTitle
					label="mainTitle"
					placeholder="mainTitle"
					title={title}
					setTitle={setTitle}
				/>
			</div>
		</Slider>
	);
};

export default RenameACL;
